import React from 'react'

import { ResidentAppError } from '../../../common/error'

export const DenyAccess: React.FC = () => {
  throw ResidentAppError.ClientError('FEATURE_ACCESS_DENIED')
}
